'use strict';

var React = require('react/addons');
var classSet = React.addons.classSet;

var SmallButton = require('components/ui/small-button');

var DatasourceContentItem = React.createClass({
  displayName: 'DatasourceContentItem',

  render: function render() {
    var component = this;

    var props = component.props;
    var selected = props.selected;
    var item = props.item;
    var forSale = item.forSale;

    var classes = { "item-component datasource-content-item-component": true, selected: selected, forSale: forSale };

    var propNodes = Object.keys(item).slice(0, 6).filter(function (key) {
      return key !== 'id';
    }).map(function (key) {
      var value = item[key];
      var result = component._toStringRepresentation(value);

      return React.createElement(
        'span',
        { key: key },
        React.createElement(
          'span',
          { className: 'key' },
          key
        ),
        React.createElement(
          'span',
          { className: 'seperator' },
          ': '
        ),
        React.createElement(
          'span',
          { className: 'value' },
          result
        )
      );
    });

    var editButton = React.createElement(SmallButton, {
      translationKey: 'edit',
      stopPropagation: true,
      onClick: props.onEditClick.bind(null, item) });

    return React.createElement(
      'div',
      { className: classSet(classes),
        onClick: props.onClick.bind(null, item.id) },
      React.createElement(
        'div',
        { className: 'properties' },
        propNodes
      ),
      React.createElement(
        'div',
        { className: 'actions' },
        editButton
      )
    );
  },

  _typeOf: function _typeOf(obj) {
    return Object.prototype.toString.call(obj).match(/\[[a-z]+ ([a-z]+)\]/i)[1].toLowerCase();
  },

  _toStringRepresentation: function _toStringRepresentation(obj) {
    var component = this;
    var type = component._typeOf(obj);
    var result = '';

    switch (type) {
      case 'string':
        if (obj.length > 25) {
          obj = obj.substring(0, 24) + '...';
        }
        result += obj;
        break;
      case 'number':
        var numString = obj.toString();
        if (numString.length === 13) {
          var numDate = new Date(obj);
          var numYear = numDate.getFullYear();
          var nowYear = new Date().getFullYear();
          if (numYear > nowYear - 1000 && numYear < nowYear + 1000) {
            result += numDate.toISOString().replace('T', ' ').replace('Z', '+0000');
            break;
          }
        }

        result += obj.toString();
        break;
      case 'array':
        var stringItems = obj.filter(function (item) {
          return component._typeOf(item) === 'string';
        });
        if (stringItems.length) {
          result += '[ ' + stringItems.join(', ') + ' ]';
        } else {
          result += '[ ' + obj.length + ' items ]';
        }
        break;
      case 'boolean':
        result += obj ? 'true' : 'false';
        break;
      default:
        result += type;
    }

    return result;
  }
});

module.exports = DatasourceContentItem;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/datasource/content-item.js
 **/